<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.plotForm"
    @close="hidePopup"
    @open="openPopup"
  >
    <van-form ref="plotForm" label-width="60px" class="form" @submit="submitForm">
      <van-field
        v-model="form.landName"
        name="landName"
        label="地块名称"
        placeholder="地块名称"
        :rules="rules.landName"
      />
      <van-field
        name="landType"
        label="地块类型"
        :rules="rules.landType"
      >
        <template #input>
          <van-radio-group
            v-model="form.landType"
            direction="horizontal"
            class="land-type-group"
          >
            <van-radio v-for="(item,key) in landTypes" :key="key" class="land-type-item" :name="item">
              {{ item }}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        label="地块位置"
        name="latLng"
      >
        <template #input>
          <land-map v-model="form.latLng" :map-edit.sync="mapEdit" @deleteMap="deleteMap" @change="mapDrawDataChange" />
        </template>
      </van-field>
      <van-row type="flex" justify="space-between">
        <van-col span="16">
          <van-field
            v-model.number="form.landArea"
            name="landArea"
            label="地块面积"
            placeholder="地块面积"
            type="decimal"
          />
        </van-col>
        <van-col span="8">
          <wh-popup-select
            v-model="form.landAreaUnit"
            name="landAreaUnit"
            :columns="landAreaUnitOptions"
          />
        </van-col>
      </van-row>
    </van-form>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import api from '@/api'
import { LAND_AREA_UNITS, LAND_TYPES } from '@/constant/common'
import LandMap from '@/views/productManage/components/LandMap'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import WhPopup from '@/components/public/WhPopup/WhPopup'

export default {
  name: 'PlotPopup',
  components: { WhPopup, WhPopupSelect, LandMap },
  mixins: [formPopup],
  data() {
    return {
      landTypes: LAND_TYPES,
      form: {
        id: undefined,
        landName: '',
        landType: '',
        landArea: 0,
        landAreaUnit: undefined,
        companyId: undefined,
        latLng: ''
      },
      rules: {
        landName: [{ required: true, message: '请填写地块名称', trigger: 'onBlur' }],
        landType: [{ required: true, message: '请选择地块类型', trigger: 'onBlur' }]
      },
      mapEdit: false,
      landAreaUnits: LAND_AREA_UNITS,
      showAreaUnitPopover: false
    }
  },
  computed: {
    landAreaUnitOptions() {
      return this.landAreaUnits.map(item => {
        return {
          text: item.name,
          value: item.name
        }
      })
    },
    title() {
      if (this.formType === 'edit') {
        return '编辑地块'
      } else {
        return '创建地块'
      }
    }
  },
  watch: {
    'form.landAreaUnit': {
      handler(newVal, oldVal) {
        if (this.form.landArea) {
          if (this.formType === 'edit') {
            this.form.landArea = this.areaConversion(newVal, this.form.landArea, newVal)
          } else {
            this.form.landArea = this.areaConversion(newVal, this.form.landArea, oldVal)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 对面积进行转换
     * @param newUnit {String} 新单位
     * @param value {Number} 要转换的值
     * @param oldUnit {String} 旧单位
     */
    areaConversion(newUnit, value, oldUnit = '平方米') {
      const units = this.landAreaUnits.map(item => item.name)
      if (units.includes(oldUnit) && units.includes(newUnit)) {
        let areaSquare = 0
        // 先统一转换为平方米
        switch (oldUnit) {
          case '平方米':
            areaSquare = value
            break
          case '亩':
            areaSquare = value / 0.0015
        }
        // 转换为相应单位值
        switch (newUnit) {
          case '平方米':
            break
          case '亩':
            areaSquare = areaSquare * 0.0015
        }
        return areaSquare
      } else {
        throw new Error(`不支持此单位类型转换（${oldUnit} > ${newUnit}）`)
      }
    },
    openPopup() {
      if (this.formType === 'create') {
        this.formDataInit(this.form, {
          companyId: this.$store.getters.companyId,
          landArea: undefined,
          landAreaUnit: '亩'
        })
      } else {
        this.formDataInit(this.form, this.initFormData)
      }
    },
    submitForm(form) {
      // console.log(form)
      let apiName = ''
      if (this.formType === 'create') {
        apiName = 'createFarmland'
      } else if (this.formType === 'edit') {
        apiName = 'updateFarmland'
      }
      api[apiName](this.form).then(res => {
        this.$toast.success(res.msg)
        this.submitFormSuccess(this.form)
        this.hidePopup()
      })
    },
    deleteMap(flag) {
      if (flag) {
        this.form.latLng = ''
        this.form.landArea = 0
      }
    },
    mapDrawDataChange(mapDrawData) {
      // const landAreaUnits = '亩'
      if (!this.form.landAreaUnit) {
        this.form.landAreaUnit = '亩'
      }
      this.form.landArea = this.areaConversion(this.form.landAreaUnit, mapDrawData.area)
    }
  }
}
</script>

<style lang='less' scoped>
.land-type-group {
  .land-type-item {
    margin-bottom: 10px;
  }
}

</style>
